import { theme } from '@dasa-health/alma-react'

export const getWindowSize = () => {
    const minMaxWidth = (sizeMin: string, sizeMax: string) =>
        window.matchMedia(`(min-width: ${sizeMin}) and (max-width: ${sizeMax})`).matches
    const maxWidth = (sizeMax: string) => window.matchMedia(`(max-width: ${sizeMax})`).matches
    const minWidth = (size: string) => window.matchMedia(`(min-width: ${size})`).matches

    return {
        sm: minMaxWidth('0px', theme.breakpoints[0]),
        md: minMaxWidth(theme.breakpoints[0], theme.breakpoints[2]),
        lg: minWidth(theme.breakpoints[2]),
        lessThan: {
            sm: maxWidth(theme.breakpoints[0]),
            md: maxWidth(theme.breakpoints[1]),
            lg: maxWidth(theme.breakpoints[2]),
        },
        greaterThan: {
            sm: minWidth(theme.breakpoints[0]),
            md: minWidth(theme.breakpoints[1]),
            lg: minWidth(theme.breakpoints[2]),
        },
    }
}
